import {isAsyncThunkAction} from '@reduxjs/toolkit'

import {PC_PAY, PAY_M} from '@web/core/urls'
import {GwError} from '@web/helpers/api'
import authCreator from '@web/middlewares/auth'
import {orderInterrupted, OrderInterruptType} from '@web/middlewares/orderInterrupted'

import {initOrderSheetByAPI} from '../../../actions/familyPay'
import {CheckoutRootState as RootState} from '../../../interfaces'

/** 주문서 로딩되기 전 액션들 모음 */
const isInitActions = isAsyncThunkAction(initOrderSheetByAPI)

const authMiddleware = authCreator<RootState>({
    /** App 이용정지 case */
    transactionStopHandler: ({next, action, isMobileDisplay}) => {
        const reason = (function () {
            try {
                const error = JSON.parse(action.error.message) as GwError
                return error.data.message
            } catch {
                return null
            }
        })()

        if (!reason) {
            return next(action)
        }

        return next(
            orderInterrupted(
                (function (): OrderInterruptType[] {
                    if (isInitActions(action)) {
                        return [
                            {
                                type: 'REDIRECT',
                                url: isMobileDisplay ? `${PAY_M}/mobile/memberStop` : `${PAY_M}/memberStop`,
                                reason,
                            },
                        ]
                    }
                    return [
                        isMobileDisplay
                            ? {
                                  type: 'ALERT',
                                  message:
                                      '회원님은 네이버페이 서비스 이용이 중지되었습니다. 관련 문의 사항은 네이버페이 고객센터로 문의하세요.',
                                  reason,
                              }
                            : {
                                  type: 'POPUP',
                                  props: [
                                      `${PC_PAY}/memberStopPopup`,
                                      'stopPopup',
                                      'width=520,height=600,alwaysRaised=yes',
                                  ],
                                  reason,
                              },
                    ]
                })(),
            ),
        )
    },
})

/** 페이 회원 인증 미들웨어  */
export default authMiddleware
